import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LaunchpadDrawer } from '../components/ui/LaunchpadDrawer';

const Container = styled('div')({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
});

interface Props {
  isAuthenticated: boolean;
}

export const PrivateRoutes: FC<Props> = ({ isAuthenticated }) => {
  return isAuthenticated ? (
    <Container>
      <LaunchpadDrawer>
        <Outlet />
      </LaunchpadDrawer>
    </Container>
  ) : (
    <Navigate to="/" />
  );
};
